import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function CheckoutCancelPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderId = searchParams.get('order_id');

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center" data-testid="checkout-cancel-page">
        <div className="w-20 h-20 rounded-full bg-yellow-100 flex items-center justify-center mx-auto mb-6">
          <span className="text-4xl">😕</span>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-slate-900 mb-3">
          Pagamento Annullato
        </h2>
        <p className="text-slate-500 mb-8">
          Il pagamento è stato annullato. Il tuo carrello è ancora disponibile.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate('/checkout')}
            data-testid="cancel-retry-btn"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#FF7043] text-white font-heading font-bold rounded-full btn-caribbean"
          >
            Riprova il Pagamento
          </button>
          <button
            onClick={() => navigate('/shop')}
            data-testid="cancel-shop-btn"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-slate-700 font-heading font-bold rounded-full border border-slate-200 hover:bg-slate-50 transition-colors"
          >
            <ArrowLeft size={16} /> Torna allo Shop
          </button>
        </div>
      </div>
    </div>
  );
}
